import { render } from "./ActualizarClave.vue?vue&type=template&id=3fd76fbe&scoped=true"
import script from "./ActualizarClave.vue?vue&type=script&lang=js"
export * from "./ActualizarClave.vue?vue&type=script&lang=js"

import "./ActualizarClave.vue?vue&type=style&index=0&id=3fd76fbe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd76fbe"]])

export default __exports__